class WIproductcard extends HTMLElement {
    constructor() {
        super();
        this.varaindId = null;
    }

    connectedCallback() {
        this.addEventListener('click', async (event) => {
            let cBlock = event.target.closest('.WI_productCardElement_color_con');
            let mobileAddBtn = event.target.closest('.WI_productCardElement_variant_mobileBtnBtn');
            if (cBlock) {
                let siblings = Array.from(cBlock.parentNode.children).filter(child => child !== cBlock);
                console.log(siblings);
                siblings.forEach(el => el.classList.remove('WI_color_active'));
                let productHandle = cBlock.getAttribute('data-producthandle');
                cBlock.classList.add('WI_color_active');
                await this.renderProductCard(productHandle);
            }
            if (mobileAddBtn) {
                let productHandle = mobileAddBtn.getAttribute('data-producthandle');
                let atcIcon = event.target.closest('.WI_productCardElement_variant_mobileBtnBtn').querySelector('.WI_atcIcon');
                let loadingSpinner = event.target.closest('.WI_productCardElement_variant_mobileBtnBtn').querySelector('.WI_loadingSpiner');
               console.log(loadingSpinner);
               atcIcon.style.display = 'none';
               loadingSpinner.style.display = 'block';
                document.dispatchEvent(new CustomEvent('quickAddPopOpen', {detail: productHandle}, {bubbles: true}));
                document.addEventListener('quickAddRendered', ()=>{
                    setTimeout(() => {
                        atcIcon.style.display = 'block';
                        loadingSpinner.style.display = 'none';
                    }, 210);
                });

            }
        });
        
        this.selectingVariant();
        this.fetchProductData();
        this.loadImages();
        document.addEventListener("productCardClicked", () => {
            this.selectingVariant();
            this.fetchProductData(); 
        });
    }

    // Rendering product card
    async renderProductCard(productData) {
        try {
            let res = await fetch(`/products/${productData}?view=rendercard`);
            let data = await res.text();
            let html_div = document.createElement('div');
            html_div.innerHTML = data;
            console.log(html_div);

            let productCardImgList = html_div.querySelector('wi-productcard .WI_productCardElement_image');
            let productCardTitle = html_div.querySelector('wi-productcard .WI_productCardElement_title');
            let productCardPrice = html_div.querySelector('wi-productcard .WI_productCardElement_price');
            let productCardVariant = html_div.querySelector('wi-productcard .WI_productCardElement_variant');
            let productCardBadge = html_div.querySelector('wi-productcard .WI_productCardElement_badge');
            let productHandle = html_div.querySelector('wi-productcard').getAttribute('data-producthandle');
            let productAtcBtnSingleVarId = html_div.querySelector('wi-productcard .WI_productCardElement_variant_atcButton').getAttribute('data-varId'); 
            let wishButton = html_div.querySelector('wi-productcard .swym-button');
            console.log(wishButton);
            


            // Replace only the clicked product card
            this.querySelector('.WI_productCardElement_title').innerHTML = productCardTitle.innerHTML;
            this.querySelector('.WI_productCardElement_price').innerHTML = productCardPrice.innerHTML;
            this.querySelector('.WI_productCardElement_image').innerHTML = productCardImgList.innerHTML;
            this.querySelector('.WI_productCardElement_variant').innerHTML = productCardVariant.innerHTML;
            this.querySelector('.WI_productCardElement_badge').innerHTML = productCardBadge.innerHTML;
            this.setAttribute('data-producthandle', productHandle);
            this.setAttribute('data-varId', productAtcBtnSingleVarId);
            // Preserve the coming soon class when switching colors
            let productCardClass = html_div.querySelector('wi-productcard').getAttribute('class');
            if (productCardClass && productCardClass.includes('WI_productCardElement_main-coming-soon')) {
                this.classList.add('WI_productCardElement_main-coming-soon');
            } else {
                this.classList.remove('WI_productCardElement_main-coming-soon');
            }
            let swymBtn = this.querySelector('.swym-button');
            if (swymBtn && wishButton) swymBtn.outerHTML = wishButton.outerHTML;
            setTimeout(() => {
                document.dispatchEvent(new CustomEvent('wishRefresh', { bubbles: true }));
            }, 1000);

            
            let reRenderSplide = this.querySelector('.WI_productCardSplide');
            var splide = new Splide( reRenderSplide, {
                type: 'slide',
                perPage: 1,
                perMove: 1,
                pagination: false,
                breakpoints: {
                    800: {
                        arrows: false
                      }
                }
            }).mount();
            this.selectingVariant();
            this.fetchProductData(); 
            

        } catch (error) {
            console.log(error); 
        }
        this.loadImages();
    }


    // Selecting variant
selectingVariant() {
    this.addEventListener('click', async (event) => {
        let varaintInputCon = event.target.closest('input[type="radio"]');
        if (varaintInputCon) {
            let variantInput = this.querySelectorAll('input[type="radio"]');
            let varArray = [];

            setTimeout(() => {
                variantInput.forEach(inp => {
                    if (inp.checked) {
                        varArray.push(inp.value);
                    }
                });

                if (varArray.length > 0) {
                    this.updateProductOptions(varArray);
                }
            }, 10);
        }
    });
}

// Update the Product options
updateProductOptions(varArray) {
    let varJSON = this.querySelector('script[type="application/json"]');
    if (varJSON) {
        let variantData = JSON.parse(varJSON.textContent);
        for (let i = 0; i < variantData.length; i++) {
            if (JSON.stringify(variantData[i].options) == JSON.stringify(varArray)) {
                console.log(variantData[i].id);
                this.updateProductVariant(variantData[i].id);
                this.fetchProductData(variantData[i].id);
                break;
            }
        }
        
    }
}

// Updating product variant
async updateProductVariant(variantid) {
    try {
        let productData = this.getAttribute('data-producthandle');
        let res = await fetch(`/products/${productData}?view=rendercard&variant=${variantid}`);
        let data = await res.text();
        let html_div = document.createElement('div');
        html_div.innerHTML = data;
        let productCardVariant = html_div.querySelector('wi-productcard .WI_quickAddVariants_main');
        let productCardClass = html_div.querySelector('wi-productcard').getAttribute('class');
        this.querySelector('.WI_quickAddVariants_main').innerHTML = productCardVariant.innerHTML;
        // Preserve the coming soon class when switching variants
        if (productCardClass && productCardClass.includes('WI_productCardElement_main-coming-soon')) {
            this.classList.add('WI_productCardElement_main-coming-soon');
        } else {
            this.classList.remove('WI_productCardElement_main-coming-soon');
        }
    } catch (error) {
        console.log(error);
    }
}


    // Fetching product data
    fetchProductData(variantid) { 
        let addToCartBtn = this.querySelector('.WI_productCardElement_variant_atcButton');
        if (!addToCartBtn) return; // Prevent errors if button is not found

        // Skip for coming soon products
        if (this.classList.contains('WI_productCardElement_main-coming-soon')) {
            return;
        }
    
        // Remove existing event listeners
        addToCartBtn.replaceWith(addToCartBtn.cloneNode(true));
        addToCartBtn = this.querySelector('.WI_productCardElement_variant_atcButton'); // Re-select button after cloning
        // Add a single event listener
        addToCartBtn.addEventListener('click', async () => {
        if (variantid == undefined) {
            variantid = addToCartBtn.getAttribute('data-varId');
        }
            try {
                let formData = {
                    'items': [{
                        'id': variantid,
                        'quantity': 1
                    }]
                };
                const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                });
                if (response.ok) {
                    document.dispatchEvent(new CustomEvent('wi:add', { bubbles: true }));
                    document.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true }));
                }
            } catch (error) {
                console.log(error);
            }
        });
    }

    // load product card images 
    loadImages() {
        let cardImages = this.querySelectorAll('.WI_productCardImage');
        cardImages.forEach(img => {
            if (img.complete) {
                setTimeout(() => {
                    img.classList.add('WI_productCardImage_load');
                }, 500);
                console.log("loaded (already complete)");
            } else {
                img.addEventListener('load', () => {
                    setTimeout(() => {
                        img.classList.add('WI_productCardImage_load');
                    }, 500);
                  console.log("loaded (on load event)");
                });
            }
        });
    }
    
    
}

customElements.define('wi-productcard', WIproductcard);
